import Box from '@mui/material/Box'
import IconButton from '@mui/material/IconButton'
import Stack from '@mui/material/Stack'
import ChevronLeftIcon from '@mui/icons-material/ChevronLeft'
import ChevronRightIcon from '@mui/icons-material/ChevronRight'
import RowsPerPageMenu from 'views/components/Pagination/RowsPerPageMenu'
import { CursorPaginationProps } from './types'

export default function CursorPaginationMui( { pageInfo, pageForward, pageBackward, rowSize, setRowSize }: CursorPaginationProps ) {
	const showPagination = !!pageInfo.hasNextPage || !!pageInfo.hasPreviousPage

	return (
		<Stack direction="row" justifyContent="space-between" alignItems="center">
			<Box>
				{ setRowSize !== undefined && (
					<RowsPerPageMenu rowsPerPage={rowSize} setRowsPerPage={setRowSize} />
				) }
			</Box>
			<Box>
				{ showPagination && (
					<Stack direction="row" gap={0.5}>
						<IconButton
							aria-label="Previous page"
							disabled={!pageInfo.hasPreviousPage}
							onClick={pageBackward( pageInfo.startCursor )}
						>
							<ChevronLeftIcon />
						</IconButton>
						<IconButton
							aria-label="Next page"
							disabled={!pageInfo.hasNextPage}
							onClick={pageForward( pageInfo.endCursor )}
						>
							<ChevronRightIcon />
						</IconButton>
					</Stack>
				) }
			</Box>
		</Stack>
	)
}
